export const getEmojiUrls = (code, type = 'png', size = '72') => {
  let uri = `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/`
  switch (type) {
    case 'svg':
      uri += `svg/${code}`
      break
    default:
      uri += `${size}x${size}/${code}`
      break
  }
  return `${uri}.${type}`
}



// WEBPACK FOOTER //
// ./src/model/emoji/EmojiTools.js